// Active dashboard configuration for the current platform.

export const global_comparisons_dashboard_id = '9e93d358-4361-4e48-9c7f-7948556ee139';

export default {
  global_comparisons_dashboard_id
};
